export default __webpack_public_path__ + "static/media/4_bottom.830d7943.png";